import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, switchMap } from 'rxjs/operators';
import { combineLatest, of } from 'rxjs';
import * as orgActions from '../actions/organization.actions';
import { ToastrService } from 'ngx-toastr';
import { AuthService } from '../../services/auth.service';
import jwt_decode from 'jwt-decode';
import { SearchOrganizations, SearchOrganizationSuccess } from '../actions';

@Injectable()
export class OrganizationEffects {
    initOrg$ = createEffect(() =>
        this.actions$.pipe(
            ofType(orgActions.OrganizationActionTypes.initOrganization),
            switchMap(() => {
                const organizationAccount = localStorage.getItem('organizationAccount');
                const organization = localStorage.getItem('organization');
                if (organizationAccount !== null) {
                    return [
                        orgActions.GetOrganizationSuccess({
                            organization: JSON.parse(organization),
                            organizationAccount: JSON.parse(organizationAccount),
                        }),
                        orgActions.GetOrganization({ organizationId: JSON.parse(organization)._id }),
                    ];
                }
                let token: any = localStorage.getItem('token');
                token = jwt_decode(token);
                return of(orgActions.GetOrganization({ organizationId: token.data.organizationId }));
            })
        )
    );

    getOrganization$ = createEffect(() =>
        this.actions$.pipe(
            ofType(orgActions.OrganizationActionTypes.getOrganization),
            switchMap((action: { organizationId: string }) =>
                combineLatest(
                    this.authService.getOrganization(action.organizationId),
                    this.authService.getOrganizationAccount(action.organizationId)
                )
            ),
            switchMap((res: any) => {
                return of(
                    orgActions.GetOrganizationSuccess({
                        organization: res[0],
                        organizationAccount: res[1],
                    })
                );
            }),
            catchError((error: any) => of(orgActions.GetOrganizationFailure(error)))
        )
    );

    SearchOrganizations$ = createEffect(() =>
        this.actions$.pipe(
            ofType(SearchOrganizations.type),
            switchMap((action: { searchTerm: string; email: string; password: string }) =>
                this.authService.searchOrganizations(action.searchTerm ?? '', action.email, action.password).pipe(
                    switchMap((res: any) => {
                        return of(SearchOrganizationSuccess({ searchedOrganizations: res.organizations }));
                    }),
                    catchError((error: any) => {
                        this.toastService.error('An error occurred!', error);
                        return of(null);
                    })
                )
            )
        )
    );

    constructor(public toastService: ToastrService, private actions$: Actions, private authService: AuthService) {}
}
